import type { TranslateFn } from '~/composables/TranslateFn'
import { OrderType } from '~/enums'
import { OrderPricingPreview } from '~/services/api/contracts/requests/OrderPricingPreview'
import { zodIssueToFieldIssues } from '~/services/api/contracts/zodIssueToFieldIssues'
import { fieldIssueMessage } from '~/services/api/fieldIssueMessage'
import type { OrderPricingPreviewRequest } from '~/services/api/generated'

interface ValidateOrderLineItemInput {
  menuItemId: number
  quantity: number
  specialInstructions: string
}

type OrderPricingPreviewItem = OrderPricingPreviewRequest['items'][number]

type ValidateOrderLineItemResult = {
  [Field in keyof Pick<OrderPricingPreviewItem, 'quantity' | 'special_instructions'>]: string | null
}

/** Shared quantity and note bounds for cart, pricing-preview and modification-request lines. */
export const validateOrderLineItem = (
  input: ValidateOrderLineItemInput,
  t: TranslateFn
): ValidateOrderLineItemResult => {
  const result = OrderPricingPreview({}).safeParse({
    items: [
      {
        menu_item_id: input.menuItemId,
        quantity: input.quantity,
        special_instructions: input.specialInstructions
      }
    ],
    order_type: OrderType.PICKUP
  })

  if (result.success) return { quantity: null, special_instructions: null }

  const messageAt = (key: 'quantity' | 'special_instructions'): string | null => {
    const issue = result.error.issues
      .flatMap(zodIssueToFieldIssues)
      .find((candidate) => candidate.source.pointer === `/items/0/${key}`)
    return issue ? fieldIssueMessage(issue, t) : null
  }

  return {
    quantity: messageAt('quantity'),
    special_instructions: messageAt('special_instructions')
  }
}
